import {Button, Card, Checkbox, Col, Form, Input, Modal, Row, Select} from 'antd';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {compose} from "redux";
import {GUTTER_MD, MARGIN_MD, MODAL_WIDTH_SM, SPAN_FULL, SPAN_HALF} from '../../../../styles/constants';
import CcPicker from '../ccPicker';
import EmbargoInput from '../../../../components/embargo-input';
import Call from '../../../../hocs/call';
import FileInput from '../../../../components/file-input';
import RowList from '../csv-form/row-list';
import {isExtensionInvalid, isIDValidWithHelp} from '../../../../utils/artefactValidators';
import {userMustNotInsertTid} from '../csv-form/utils';
import {getLoaderConfiguredPlugins, setLoaderConfiguredPlugin} from '../actions';
import {
    changeLoaderCsvForm,
    convertLoaderPluginToCsv,
    onHideLoaderCsvFormIgnoreConcurrentUploadConfirm, resetFields,
    submitLoaderCsvForm,
    submitLoaderCsvFormWithSeqMapping,
    uploadLoaderPluginFormFile,
    hideModalReviewDataflows,
    uploadDataflowBuilder
} from '../csv-form/actions';
import MappingControl from '../csv-form/mapping-control';
import {showLoaderCsvFormRowList} from '../csv-form/row-list/actions';
import {DataLanguageConsumer} from '../../../../contexts/DataLanguage';
import EnhancedModal from "../../../../components/enhanced-modal";

const mapStateToProps = state => ({
    nodeId: state.app.endpointId,
    appLanguage: state.app.language,
    permissions: state.app.user.permissions,
    mappingId: state.scenes.dataManager.loader.components.csvForm.shared.mappingId,
    mapping: state.scenes.dataManager.loader.components.csvForm.shared.mapping,
    mappingCube: state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,
    format: state.scenes.dataManager.loader.shared.format,
    configuredPlugin: state.scenes.dataManager.loader.components.csvForm.shared.configuredPlugin,
    csvServerPath: state.scenes.dataManager.loader.components.csvForm.shared.csvServerPath,
    embargo: state.scenes.dataManager.loader.components.csvForm.local.embargo,
    fileServerPath: state.scenes.dataManager.loader.components.csvForm.shared.fileServerPath,
    configuredPlugins: state.scenes.dataManager.loader.shared.configuredPlugins,
    refreshProdDf: state.scenes.dataManager.loader.components.csvForm.local.refreshProdDf,
    checkFiltAttributes: state.scenes.dataManager.loader.components.csvForm.local.checkFiltAttributes,
    ccFileServerPath: state.scenes.dataManager.loader.shared.ccFileServerPath,
    cc: state.scenes.dataManager.loader.shared.cc,
    selectedMappingIsSequence: state.scenes.dataManager.loader.components.csvForm.shared.selectedMappingIsSequence,
    seqMappings: state.scenes.dataManager.loader.components.csvForm.shared.seqMappings,
    seqMappingsIndex: state.scenes.dataManager.loader.components.csvForm.shared.seqMappingsIndex,
    prevSeqMappingIndex: state.scenes.dataManager.loader.components.csvForm.shared.prevSeqMappingsIndex,
    file: state.scenes.dataManager.loader.components.csvForm.local.file,
    importType: state.scenes.dataManager.loader.components.csvForm.local.importType,
    hasHeader: state.scenes.dataManager.loader.components.csvForm.shared.hasHeader,
    separator: state.scenes.dataManager.loader.components.csvForm.shared.separator,
    delimiter: state.scenes.dataManager.loader.components.csvForm.shared.delimiter,
    transformFileInput: state.scenes.dataManager.loader.components.csvForm.shared.transformFileInput,
    processFileInput: state.scenes.dataManager.loader.components.csvForm.shared.processFileInput,
    secondServerPath: state.scenes.dataManager.loader.components.csvForm.shared.secondServerPath,
    thirdServerPath: state.scenes.dataManager.loader.components.csvForm.shared.thirdServerPath,
    isIgnoreConcurrentUploadConfirmVisible: state.scenes.dataManager.loader.components.csvForm.local.isIgnoreConcurrentUploadConfirmVisible,
    hasDotStatFormat: state.scenes.dataManager.loader.components.csvForm.shared.hasDotStatFormat,
    tid: state.scenes.dataManager.loader.components.csvForm.shared.tid,
    hasMappingFieldExpressions: state.scenes.dataManager.loader.components.csvForm.shared.hasMappingFieldExpressions,
    showModalDataflowsReview: state.scenes.dataManager.loader.components.csvForm.shared.showModalDataflowsReview,
})

const mapDispatchToProps = dispatch => ({
    getConfiguredPlugins: nodeId => dispatch(getLoaderConfiguredPlugins(nodeId)),
    setConfiguredPlugin: (plugin) => dispatch(setLoaderConfiguredPlugin(plugin)),
    onChange: fields => dispatch(changeLoaderCsvForm(fields)),
    onFileUpload: (pluginUid, file, mappingCubeId, format, transformFile, processFile) =>
        dispatch(uploadLoaderPluginFormFile(pluginUid, file, mappingCubeId, format, transformFile, processFile)),
    onRowListShow: () => dispatch(showLoaderCsvFormRowList()),
    onSubmit: (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, cc, ccFileServerPath, hasMappingFieldExpressions) =>
        dispatch(submitLoaderCsvForm(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, cc, ccFileServerPath, 2, false, hasMappingFieldExpressions)),
    onHideIgnoreConcurrentUploadConfirm: () => dispatch(onHideLoaderCsvFormIgnoreConcurrentUploadConfirm()),
    onConvertPluginToCsv: ({
                               pluginUid,
                               fileServerPath,
                               transformFileServerPath,
                               processFileServerPath,
                               lang,
                               dllName,
                               idCube,
                               deleteFile
                           }) => dispatch(convertLoaderPluginToCsv(pluginUid, fileServerPath, transformFileServerPath, processFileServerPath, lang, '.csv', dllName, idCube, deleteFile)),
    onResetFields: () => dispatch(resetFields()),
    onSubmitWithSequenceMapping: (importType, seqMappingId, cubeCode, filePath, tid, refreshProdDf, embargo, ignoreConcurrentUpload, checkFiltAttributes, ccTriplet, resultItems, ccFileServerPath, pluginUid) =>
        dispatch(submitLoaderCsvFormWithSeqMapping(importType, seqMappingId, cubeCode, filePath, tid, refreshProdDf, embargo, ignoreConcurrentUpload, checkFiltAttributes, ccTriplet, resultItems, ccFileServerPath, pluginUid)),
    onHideModalDataflowsReview: () => dispatch(hideModalReviewDataflows()),
    uploadDataflowBuilder: (cubeId) => dispatch(uploadDataflowBuilder(cubeId)),
})

const mapPropsToFields = ({
                              mapping,
                              tid,
                              importType,
                              file,
                              embargo,
                              refreshProdDf,
                              checkFiltAttributes,
                              configuredPlugin,
                              transformFileInput,
                              processFileInput,
                              hasHeader,
                              hasDotStatFormat
                          }) => ({
    mappingId: Form.createFormField({value: mapping !== null ? `[${mapping.Name}] ${mapping.Description || ''}` : null}),
    tid: Form.createFormField({value: tid}),
    importType: Form.createFormField({value: importType}),
    file: Form.createFormField({value: file}),
    embargo: Form.createFormField({value: embargo}),
    hasHeader: Form.createFormField({value: hasHeader}),
    hasDotStatFormat: Form.createFormField({value: hasDotStatFormat}),
    refreshProdDf: Form.createFormField({value: refreshProdDf}),
    checkFiltAttributes: Form.createFormField({value: checkFiltAttributes}),
    configuredPlugin: Form.createFormField({value: configuredPlugin}),
    transformFileInput: Form.createFormField({value: transformFileInput || null}),
    processFileInput: Form.createFormField({value: processFileInput || null}),
})

const onFieldsChange = (props, fields) => props.onChange(fields);

const LoaderPluginForm = ({
                              t,
                              appLanguage,
                              form,
                              format,
                              nodeId,
                              configuredPlugin,
                              embargo,
                              importType,
                              csvServerPath,
                              fileServerPath,
                              tid,
                              configuredPlugins = [],
                              getConfiguredPlugins,
                              mapping,
                              mappingId,
                              mappingCube,
                              selectedMappingIsSequence,
                              onRowListShow,
                              file,
                              onFileUpload,
                              permissions,
                              onConvertPluginToCsv,
                              hasHeader,
                              transformFileInput,
                              processFileInput,
                              separator,
                              delimiter,
                              ccFileServerPath,
                              onSubmit,
                              onSubmitWithSequenceMapping,
                              isIgnoreConcurrentUploadConfirmVisible,
                              onHideIgnoreConcurrentUploadConfirm,
                              refreshProdDf,
                              checkFiltAttributes,
                              cc,
                              hasDotStatFormat,
                              seqMappings,
                              onResetFields,
                              seqMappingsIndex,
                              prevSeqMappingIndex,
                              hasMappingFieldExpressions,
                              showModalDataflowsReview,
                              onHideModalDataflowsReview,
                              uploadDataflowBuilder,
                          }) => {
    const selectedPlugin = useMemo(() => {
        if (!!permissions && permissions.functionality.includes("plugins") && configuredPlugins) {
            return configuredPlugins.find(plugin => plugin.PluginUid === configuredPlugin);
        }
    }, [permissions, configuredPlugin]);

    const selectedMappingPathOfSequence = useMemo(() => {
        if (!seqMappings || seqMappings.length === 0) {
            return "";
        }
        return seqMappings[seqMappingsIndex >= 0 ? seqMappingsIndex : 0].XMLFilePath;
    }, [seqMappings, seqMappingsIndex]);

    useEffect(() => {
        if (selectedPlugin) {
            onResetFields();
            form.setFieldsValue({
                mappingId: null,
                tid: null,
                importType: "SeriesAndData",
                file: null,
                embargo: null,
                hasHeader: null,
                hasDotStatFormat: null,
                refreshProdDf: null,
                checkFiltAttributes: null,
                transformFileInput: null,
                processFileInput: null
            });
        }
    }, [selectedPlugin]);

    const submit = useCallback((ignoreConcurrentUpload = false) => !selectedMappingIsSequence ? onSubmit(
        separator,
        !!delimiter ? delimiter : null,
        hasHeader,
        importType,
        mappingCube.IDCube,
        mappingId,
        csvServerPath,
        tid,
        mappingCube.Code,
        hasDotStatFormat ? mappingId : null,
        embargo ? embargo.enabled : false,
        refreshProdDf,
        checkFiltAttributes,
        ignoreConcurrentUpload,
        cc,
        ccFileServerPath,
        hasMappingFieldExpressions
        ) : onSubmitWithSequenceMapping(
        importType,
        mappingId,
        mappingCube.IDCube,
        fileServerPath,
        tid,
        refreshProdDf,
        embargo ? embargo.enabled : false,
        ignoreConcurrentUpload,
        checkFiltAttributes,
        cc,
        (seqMappings || []).map(mapping => mapping.Name),
        ccFileServerPath,
        selectedPlugin.PluginUid
    ), [selectedMappingIsSequence, onSubmit, onSubmitWithSequenceMapping, separator, delimiter, hasHeader,
        importType, mappingCube, mappingId, csvServerPath, tid, fileServerPath, hasDotStatFormat, embargo, refreshProdDf,
        checkFiltAttributes, cc, ccFileServerPath, hasMappingFieldExpressions, selectedPlugin, seqMappings]);

    const [idCube, setIdCube] = useState(0)

    return (
        <DataLanguageConsumer>
            {dataLanguage => {
                const lang = dataLanguage || appLanguage;
                return (
                    <Call cb={getConfiguredPlugins} cbParam={nodeId}
                          disabled={!!configuredPlugin || format !== 'plugin' || (!!permissions && !permissions.functionality.includes("plugins"))}
                    >
                        <Call cb={onConvertPluginToCsv}
                              cbParam={{
                                  pluginUid: selectedPlugin ? selectedPlugin.PluginUid : null,
                                  fileServerPath,
                                  transformFileServerPath: !selectedMappingIsSequence ? mapping ? mapping.XMLFilePath : "" : selectedMappingPathOfSequence,
                                  processFileServerPath: "",
                                  lang: appLanguage,
                                  dllName: selectedPlugin ? selectedPlugin.DllName : null,
                                  idCube: mappingCube ? mappingCube.IDCube : 0,
                                  deleteFile: !selectedMappingIsSequence
                              }}
                              disabled={format !== 'plugin' || mappingId === null || fileServerPath === null || !selectedPlugin || (csvServerPath !== null && seqMappingsIndex === 0 && prevSeqMappingIndex === seqMappingsIndex)}
                        >
                            <Row type="flex" justify="center">
                                <Col style={{width: MODAL_WIDTH_SM}}>
                                    <Card type="inner">
                                        <Form className="advanced-form">
                                            <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                                                <Col span={SPAN_FULL}>
                                                    <Form.Item className="form-item-required"
                                                               label={t('scenes.dataManager.loader.pluginForm.fields.plugin.label')}>
                                                        {form.getFieldDecorator('configuredPlugin')(
                                                            <Select
                                                                showSearch
                                                                filterOption={(inputValue, {props}) =>
                                                                    props.title.toLowerCase().includes(inputValue.toLowerCase())
                                                                }
                                                                disabled={!configuredPlugins}
                                                                title={configuredPlugin}
                                                            >
                                                                {
                                                                    configuredPlugins ?
                                                                        configuredPlugins.map((plugin) => (
                                                                            <Select.Option
                                                                                key={plugin.PluginUid}
                                                                                value={plugin.PluginUid}
                                                                                title={plugin.PluginName[lang]}
                                                                            >
                                                                                {plugin.PluginName[lang]}
                                                                            </Select.Option>
                                                                        )) :
                                                                        null
                                                                }
                                                            </Select>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {!!selectedPlugin &&
                                                <React.Fragment>
                                                    <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                                                        <Col span={SPAN_FULL}>
                                                            <Form.Item className="form-item-required"
                                                                       label={t('scenes.dataManager.loader.pluginForm.fields.mapping.label')}>
                                                                <MappingControl
                                                                    form={form}
                                                                    format={"plugin"}
                                                                    pluginId={selectedPlugin.PluginUid}
                                                                    sequenceMappingEnabled={selectedPlugin.SequenceMappingEnabled}/>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    {!userMustNotInsertTid(mapping, mappingCube) && (
                                                        <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                                                            <Col span={SPAN_FULL}>
                                                                <Form.Item
                                                                    className="form-item-required"
                                                                    label={t('scenes.dataManager.loader.pluginForm.fields.tid.label')}
                                                                    validateStatus={tid && isIDValidWithHelp(t, tid).help ? "warning" : null}
                                                                    help={tid && isIDValidWithHelp(t, tid).help}
                                                                >
                                                                    {form.getFieldDecorator('tid', {
                                                                        getValueFromEvent: e => e.target.value.toUpperCase()
                                                                    })(<Input style={{textTransform: "uppercase"}}/>)}
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                                                        <Col span={SPAN_FULL}>
                                                            <Form.Item
                                                                className="form-item-required"
                                                                label={t('scenes.dataManager.loader.pluginForm.fields.importType.label')}
                                                            >
                                                                {form.getFieldDecorator('importType')(
                                                                    <Select
                                                                        showSearch
                                                                        filterOption={(inputValue, {props}) =>
                                                                            props.title.toLowerCase().includes(inputValue.toLowerCase())
                                                                        }
                                                                        disabled={mappingId === null ||
                                                                            (
                                                                                !userMustNotInsertTid(mapping, mappingCube)
                                                                                &&
                                                                                (!tid || tid.length === 0)
                                                                            )
                                                                        }
                                                                    >
                                                                        <Select.Option
                                                                            value="SeriesAndData"
                                                                            title={t('scenes.dataManager.loader.pluginForm.fields.importType.option.SeriesAndData')}
                                                                        >
                                                                            {t('scenes.dataManager.loader.pluginForm.fields.importType.option.SeriesAndData')}
                                                                        </Select.Option>
                                                                        <Select.Option
                                                                            value="Series"
                                                                            title={t('scenes.dataManager.loader.pluginForm.fields.importType.option.Series')}
                                                                        >
                                                                            {t('scenes.dataManager.loader.pluginForm.fields.importType.option.Series')}
                                                                        </Select.Option>
                                                                        <Select.Option
                                                                            value="Data"
                                                                            title={t('scenes.dataManager.loader.pluginForm.fields.importType.option.Data')}
                                                                        >
                                                                            {t('scenes.dataManager.loader.pluginForm.fields.importType.option.Data')}
                                                                        </Select.Option>
                                                                    </Select>
                                                                )}
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={GUTTER_MD} style={{marginBottom: MARGIN_MD}}>
                                                        <Col span={SPAN_FULL}>
                                                            <Form.Item className="form-item-required"
                                                                       label={t('scenes.dataManager.loader.pluginForm.fields.file.label')}
                                                                       validateStatus={format === 'plugin' && file && isExtensionInvalid(file.name, selectedPlugin.InputExtensions) ? "warning" : null}
                                                                       help={format === 'plugin' && file && isExtensionInvalid(file.name, selectedPlugin.InputExtensions) ? t("scenes.utilities.plugin.modal.input.messages.invalidExtension") : null}
                                                            >
                                                                {form.getFieldDecorator('file')(
                                                                    <FileInput
                                                                        disabled={
                                                                            mappingId === null ||
                                                                            (
                                                                                !userMustNotInsertTid(mapping, mappingCube)
                                                                                &&
                                                                                (!tid || tid.length === 0)
                                                                            )
                                                                        }
                                                                        accept={(selectedPlugin ? selectedPlugin.InputExtensions : []).join(",")}
                                                                        isZipAllowed
                                                                    />
                                                                )}
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row type="flex" justify="center" gutter={GUTTER_MD}
                                                         style={{marginBottom: MARGIN_MD}}>
                                                        <Col>
                                                            <Form.Item>
                                                                <Button
                                                                    onClick={() =>
                                                                        onFileUpload(
                                                                            selectedPlugin.PluginUid,
                                                                            file,
                                                                            mappingCube.IDCube,
                                                                            '.csv',
                                                                            transformFileInput,
                                                                            processFileInput
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        (
                                                                            !userMustNotInsertTid(mapping, mappingCube)
                                                                            &&
                                                                            (!tid || tid.length === 0)
                                                                        ) ||
                                                                        mappingCube === null ||
                                                                        file === null ||
                                                                        (file && isExtensionInvalid(file.name, selectedPlugin.InputExtensions))
                                                                    }
                                                                    type="primary"
                                                                    icon="upload"
                                                                >
                                                                    {t('data.csv.uploadButton.label')}
                                                                </Button>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item>
                                                                <Button
                                                                    onClick={onRowListShow}
                                                                    disabled={csvServerPath === null}
                                                                    icon="table">
                                                                    {t('data.csv.tableShowButton.label')}
                                                                </Button>
                                                                <RowList/>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <CcPicker/>
                                                    <Row type="flex" style={{marginBottom: MARGIN_MD}}>
                                                        <Col span={SPAN_FULL}>
                                                            <Form.Item>
                                                                {form.getFieldDecorator('embargo')(
                                                                    <EmbargoInput disabled={csvServerPath === null}/>
                                                                )}
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row type="flex" style={{marginBottom: MARGIN_MD}}>
                                                        <Col span={SPAN_HALF}>
                                                            <Form.Item
                                                                label={t('scenes.dataManager.loader.pluginForm.fields.refreshProdDf.label')}>
                                                                {form.getFieldDecorator('refreshProdDf', {valuePropName: 'checked'})(
                                                                    <Checkbox disabled={fileServerPath === null}/>)}
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={SPAN_HALF}>
                                                            <Form.Item
                                                                label={t('scenes.dataManager.loader.pluginForm.fields.checkFiltAttributes.label')}>
                                                                {form.getFieldDecorator('checkFiltAttributes', {valuePropName: 'checked'})(
                                                                    <Checkbox disabled={fileServerPath === null}/>)}
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row type="flex" justify="center">
                                                        <Form.Item>
                                                            <Call
                                                                cb={() => Modal.confirm({
                                                                    title: t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.title'),
                                                                    content: t('scenes.dataManager.loader.confirms.ignoreConcurrentUpload.content'),
                                                                    onOk() {
                                                                        submit(true);
                                                                        onHideIgnoreConcurrentUploadConfirm();
                                                                    },
                                                                    onCancel() {
                                                                        onHideIgnoreConcurrentUploadConfirm();
                                                                    },
                                                                    cancelText: t('commons.buttons.cancel.title')
                                                                })}
                                                                disabled={!isIgnoreConcurrentUploadConfirmVisible}
                                                            >
                                                                <Button
                                                                    onClick={() => {
                                                                      setIdCube(mappingCube.IDCube);
                                                                      Modal.confirm({
                                                                        title: t('scenes.dataManager.loader.confirms.submit.title'),
                                                                        onOk() {
                                                                            submit()
                                                                        },
                                                                        cancelText: t('commons.buttons.cancel.title')
                                                                    })}}
                                                                    disabled={
                                                                        mappingId === null || mappingCube === null || importType === null ||
                                                                        (
                                                                            !userMustNotInsertTid(mapping, mappingCube)
                                                                            &&
                                                                            (!tid || tid.length === 0)
                                                                        )
                                                                        || csvServerPath === null
                                                                    }
                                                                    type="primary"
                                                                    icon="check"
                                                                >
                                                                    {t('scenes.dataManager.loader.csvForm.submitButton.label')}
                                                                </Button>
                                                            </Call>
                                                        </Form.Item>
                                                    </Row>
                                                </React.Fragment>}
                                                <React.Fragment>
                                                  <EnhancedModal
                                                    visible={showModalDataflowsReview}
                                                    title={t("scenes.dataManager.loader.modals.dataflowReview.title")}
                                                    onCancel={onHideModalDataflowsReview}
                                                    footer={
                                                      <React.Fragment>
                                                        <Button onClick={onHideModalDataflowsReview}>
                                                          {t("commons.buttons.cancel.title")}
                                                        </Button>
                                                        <Button
                                                          type="primary"
                                                          onClick={() => uploadDataflowBuilder(idCube)}
                                                        >
                                                          {t("commons.buttons.confirm.title")}
                                                        </Button>
                                                      </React.Fragment>
                                                    }
                                                    width={MODAL_WIDTH_SM}
                                                  >
                                                    <Row>
                                                      {t("scenes.dataManager.loader.modals.dataflowReview.content")}
                                                    </Row>
                                                  </EnhancedModal>
                                                </React.Fragment>
                                        </Form>
                                    </Card>
                                </Col>
                            </Row>
                        </Call>
                    </Call>
                )
            }}
        </DataLanguageConsumer>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({
        mapPropsToFields,
        onFieldsChange
    })
)(LoaderPluginForm)